import React, { useRef } from 'react';
import { FocusTrap } from 'focus-trap-react';

interface Props {
    ddInput: string[];
    showDropDown: boolean;
    setShowDropDown: (showDropDown: boolean) => void;
    toggleDropDown: Function;
    ddSelection: Function;
    popUpBlocker: boolean;
    setPopUpBlocker: (popUpBlocker: boolean) => void;
    setShowPageLoading: (show: boolean) => void;
};

export const DropDown = ({ ddInput,showDropDown, setShowDropDown, toggleDropDown, ddSelection, popUpBlocker, setPopUpBlocker, setShowPageLoading }: Props) => {

    const itemRefs = useRef<(HTMLParagraphElement | null)[]>([]);
    const closedByClickRef = useRef(false);
     
    const onClickHandler = (ddName: string, index:number): void => {
        setShowPageLoading(true);
        closedByClickRef.current = true;
        //setPopUpBlocker(false);
        ddSelection(ddName,index);
        toggleDropDown();
    };


    const handleItemKeyDown = (e: React.KeyboardEvent<HTMLParagraphElement>, index: number) => {
      switch (e.key) {
          case "Tab":
              e.preventDefault();
              const tabIndex = index < ddInput.length - 1 ? index + 1 : 0;
              itemRefs.current[tabIndex]?.focus();
              break;
          case "ArrowDown":
              e.preventDefault();
              const nextIndex = index < ddInput.length - 1 ? index + 1 : 0;
              itemRefs.current[nextIndex]?.focus();
              break;
          case "ArrowUp":
              e.preventDefault();
              const prevIndex = index > 0 ? index - 1 : ddInput.length - 1;
              itemRefs.current[prevIndex]?.focus();
              break;
          case "Enter":
          case " ":
              onClickHandler(ddInput[index], index);
              break;
      }
  };

    return (
        <FocusTrap
          active={showDropDown}
          focusTrapOptions={{
              clickOutsideDeactivates: true,
              escapeDeactivates: true,
              onDeactivate: () => {
                if (closedByClickRef.current) {
                    closedByClickRef.current = false;
                    return;
                }
                toggleDropDown();
                setTimeout(() => {
                    setPopUpBlocker(false);
                }, 150);
              },
              returnFocusOnDeactivate: true,
            }}
        >
            {/* <div className={showDropDown ? 'dropdown' : 'dropdown active'}> */}
            <div role="menu">
                {ddInput.map(
                    (ddName: string, index: number): JSX.Element => {
                        return (
                            <p 
                                id="dropdown-item"
                                key={ddName}
                                role="menuitem"
                                ref={(el) => (itemRefs.current[index] = el)}
                                tabIndex={0}
                                onKeyDown={(e) => handleItemKeyDown(e, index)}
                                onClick={(): void => {
                                    onClickHandler(ddName,index);
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                {ddName.split('<>')[0]}
                            </p>
                        );
                    }
                )}
            </div>
        </FocusTrap>
    );
}; 